import { render, staticRenderFns } from "./FormTemplatesOverview.vue?vue&type=template&id=607d5a88&scoped=true&"
import script from "./FormTemplatesOverview.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesOverview.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplatesOverview.vue?vue&type=style&index=0&id=607d5a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d5a88",
  null
  
)

export default component.exports